import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React from "react";
import { DatagridConfigurable, List, NumberField, ReferenceField, TextField, TextInput, } from "react-admin";
import { ListActions } from "../../components/ListActions";
import { Typography } from "@mui/material";
import { generateRowClickHandler } from "../../services/RowClickService";
import { useTenantStore } from "../../providers/TenantContextProvider";
var OMIT_FIELDS = ["id"];
var Filters = [
    _jsx(TextInput, { label: "Name", source: "name" }, 0),
    _jsx(TextInput, { label: "Media Type", source: "media_type" }, 1),
    _jsx(TextInput, { label: "ID", source: "id" }, 2),
    _jsx(TextInput, { label: "Election Event ID", source: "election_event_id" }, 3),
];
export var ListDocument = function (_a) {
    var aside = _a.aside;
    var tenantId = useTenantStore()[0];
    var _b = React.useState(false), openDrawer = _b[0], setOpenDrawer = _b[1];
    var rowClickHandler = generateRowClickHandler(["election_event_id"], true);
    return (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "h5", children: "Documents" }), _jsx(List, { actions: _jsx(ListActions, { open: openDrawer, setOpen: setOpenDrawer, withFilter: true }), filter: { tenant_id: tenantId || undefined }, aside: aside || _jsx("div", { children: "hey" }), filters: Filters, children: _jsxs(DatagridConfigurable, { rowClick: rowClickHandler, omit: OMIT_FIELDS, children: [_jsx(TextField, { source: "id" }), _jsx(TextField, { source: "name" }), _jsx(TextField, { source: "media_type" }), _jsx(NumberField, { source: "size" }), _jsx(ReferenceField, { source: "election_event_id", reference: "sequent_backend_election_event", children: _jsx(TextField, { source: "name" }) })] }) })] }));
};
